const Timezones = [
    "Africa\/Abidjan",
    "Africa\/Accra",
    "Africa\/Addis_Ababa",
    "Africa\/Algiers",
    "Africa\/Asmara",
    "Africa\/Bamako",
    "Africa\/Bangui",
    "Africa\/Banjul",
    "Africa\/Bissau",
    "Africa\/Blantyre",
    "Africa\/Brazzaville",
    "Africa\/Bujumbura",
    "Africa\/Cairo",
    "Africa\/Casablanca",
    "Africa\/Ceuta",
    "Africa\/Conakry",
    "Africa\/Dakar",
    "Africa\/Dar_es_Salaam",
    "Africa\/Djibouti",
    "Africa\/Douala",
    "Africa\/El_Aaiun",
    "Africa\/Freetown",
    "Africa\/Gaborone",
    "Africa\/Harare",
    "Africa\/Johannesburg",
    "Africa\/Juba",
    "Africa\/Kampala",
    "Africa\/Khartoum",
    "Africa\/Kigali",
    "Africa\/Kinshasa",
    "Africa\/Lagos",
    "Africa\/Libreville",
    "Africa\/Lome",
    "Africa\/Luanda",
    "Africa\/Lubumbashi",
    "Africa\/Lusaka",
    "Africa\/Malabo",
    "Africa\/Maputo",
    "Africa\/Maseru",
    "Africa\/Mbabane",
    "Africa\/Mogadishu",
    "Africa\/Monrovia",
    "Africa\/Nairobi",
    "Africa\/Ndjamena",
    "Africa\/Niamey",
    "Africa\/Nouakchott",
    "Africa\/Ouagadougou",
    "Africa\/Porto-Novo",
    "Africa\/Sao_Tome",
    "Africa\/Tripoli",
    "Africa\/Tunis",
    "Africa\/Windhoek",
    "America\/Adak",
    "America\/Anchorage",
    "America\/Anguilla",
    "America\/Antigua",
    "America\/Araguaina",
    "America\/Argentina\/Buenos_Aires",
    "America\/Argentina\/Catamarca",
    "America\/Argentina\/Cordoba",
    "America\/Argentina\/Jujuy",
    "America\/Argentina\/La_Rioja",
    "America\/Argentina\/Mendoza",
    "America\/Argentina\/Rio_Gallegos",
    "America\/Argentina\/Salta",
    "America\/Argentina\/San_Juan",
    "America\/Argentina\/San_Luis",
    "America\/Argentina\/Tucuman",
    "America\/Argentina\/Ushuaia",
    "America\/Aruba",
    "America\/Asuncion",
    "America\/Atikokan",
    "America\/Bahia",
    "America\/Bahia_Banderas",
    "America\/Barbados",
    "America\/Belem",
    "America\/Belize",
    "America\/Blanc-Sablon",
    "America\/Boa_Vista",
    "America\/Bogota",
    "America\/Boise",
    "America\/Cambridge_Bay",
    "America\/Campo_Grande",
    "America\/Cancun",
    "America\/Caracas",
    "America\/Cayenne",
    "America\/Cayman",
    "America\/Chicago",
    "America\/Chihuahua",
    "America\/Ciudad_Juarez",
    "America\/Costa_Rica",
    "America\/Creston",
    "America\/Cuiaba",
    "America\/Curacao",
    "America\/Danmarkshavn",
    "America\/Dawson",
    "America\/Dawson_Creek",
    "America\/Denver",
    "America\/Detroit",
    "America\/Dominica",
    "America\/Edmonton",
    "America\/Eirunepe",
    "America\/El_Salvador",
    "America\/Fort_Nelson",
    "America\/Fortaleza",
    "America\/Glace_Bay",
    "America\/Goose_Bay",
    "America\/Grand_Turk",
    "America\/Grenada",
    "America\/Guadeloupe",
    "America\/Guatemala",
    "America\/Guayaquil",
    "America\/Guyana",
    "America\/Halifax",
    "America\/Havana",
    "America\/Hermosillo",
    "America\/Indiana\/Indianapolis",
    "America\/Indiana\/Knox",
    "America\/Indiana\/Marengo",
    "America\/Indiana\/Petersburg",
    "America\/Indiana\/Tell_City",
    "America\/Indiana\/Vevay",
    "America\/Indiana\/Vincennes",
    "America\/Indiana\/Winamac",
    "America\/Inuvik",
    "America\/Iqaluit",
    "America\/Jamaica",
    "America\/Juneau",
    "America\/Kentucky\/Louisville",
    "America\/Kentucky\/Monticello",
    "America\/Kralendijk",
    "America\/La_Paz",
    "America\/Lima",
    "America\/Los_Angeles",
    "America\/Lower_Princes",
    "America\/Maceio",
    "America\/Managua",
    "America\/Manaus",
    "America\/Marigot",
    "America\/Martinique",
    "America\/Matamoros",
    "America\/Mazatlan",
    "America\/Menominee",
    "America\/Merida",
    "America\/Metlakatla",
    "America\/Mexico_City",
    "America\/Miquelon",
    "America\/Moncton",
    "America\/Monterrey",
    "America\/Montevideo",
    "America\/Montserrat",
    "America\/Nassau",
    "America\/New_York",
    "America\/Nome",
    "America\/Noronha",
    "America\/North_Dakota\/Beulah",
    "America\/North_Dakota\/Center",
    "America\/North_Dakota\/New_Salem",
    "America\/Nuuk",
    "America\/Ojinaga",
    "America\/Panama",
    "America\/Paramaribo",
    "America\/Phoenix",
    "America\/Port-au-Prince",
    "America\/Port_of_Spain",
    "America\/Porto_Velho",
    "America\/Puerto_Rico",
    "America\/Punta_Arenas",
    "America\/Rankin_Inlet",
    "America\/Recife",
    "America\/Regina",
    "America\/Resolute",
    "America\/Rio_Branco",
    "America\/Santarem",
    "America\/Santiago",
    "America\/Santo_Domingo",
    "America\/Sao_Paulo",
    "America\/Scoresbysund",
    "America\/Sitka",
    "America\/St_Barthelemy",
    "America\/St_Johns",
    "America\/St_Kitts",
    "America\/St_Lucia",
    "America\/St_Thomas",
    "America\/St_Vincent",
    "America\/Swift_Current",
    "America\/Tegucigalpa",
    "America\/Thule",
    "America\/Tijuana",
    "America\/Toronto",
    "America\/Tortola",
    "America\/Vancouver",
    "America\/Whitehorse",
    "America\/Winnipeg",
    "America\/Yakutat",
    "Antarctica\/Casey",
    "Antarctica\/Davis",
    "Antarctica\/DumontDUrville",
    "Antarctica\/Macquarie",
    "Antarctica\/Mawson",
    "Antarctica\/McMurdo",
    "Antarctica\/Palmer",
    "Antarctica\/Rothera",
    "Antarctica\/Syowa",
    "Antarctica\/Troll",
    "Antarctica\/Vostok",
    "Arctic\/Longyearbyen",
    "Asia\/Aden",
    "Asia\/Almaty",
    "Asia\/Amman",
    "Asia\/Anadyr",
    "Asia\/Aqtau",
    "Asia\/Aqtobe",
    "Asia\/Ashgabat",
    "Asia\/Atyrau",
    "Asia\/Baghdad",
    "Asia\/Bahrain",
    "Asia\/Baku",
    "Asia\/Bangkok",
    "Asia\/Barnaul",
    "Asia\/Beirut",
    "Asia\/Bishkek",
    "Asia\/Brunei",
    "Asia\/Chita",
    "Asia\/Choibalsan",
    "Asia\/Colombo",
    "Asia\/Damascus",
    "Asia\/Dhaka",
    "Asia\/Dili",
    "Asia\/Dubai",
    "Asia\/Dushanbe",
    "Asia\/Famagusta",
    "Asia\/Gaza",
    "Asia\/Hebron",
    "Asia\/Ho_Chi_Minh",
    "Asia\/Hong_Kong",
    "Asia\/Hovd",
    "Asia\/Irkutsk",
    "Asia\/Jakarta",
    "Asia\/Jayapura",
    "Asia\/Jerusalem",
    "Asia\/Kabul",
    "Asia\/Kamchatka",
    "Asia\/Karachi",
    "Asia\/Kathmandu",
    "Asia\/Khandyga",
    "Asia\/Kolkata",
    "Asia\/Krasnoyarsk",
    "Asia\/Kuala_Lumpur",
    "Asia\/Kuching",
    "Asia\/Kuwait",
    "Asia\/Macau",
    "Asia\/Magadan",
    "Asia\/Makassar",
    "Asia\/Manila",
    "Asia\/Muscat",
    "Asia\/Nicosia",
    "Asia\/Novokuznetsk",
    "Asia\/Novosibirsk",
    "Asia\/Omsk",
    "Asia\/Oral",
    "Asia\/Phnom_Penh",
    "Asia\/Pontianak",
    "Asia\/Pyongyang",
    "Asia\/Qatar",
    "Asia\/Qostanay",
    "Asia\/Qyzylorda",
    "Asia\/Riyadh",
    "Asia\/Sakhalin",
    "Asia\/Samarkand",
    "Asia\/Seoul",
    "Asia\/Shanghai",
    "Asia\/Singapore",
    "Asia\/Srednekolymsk",
    "Asia\/Taipei",
    "Asia\/Tashkent",
    "Asia\/Tbilisi",
    "Asia\/Tehran",
    "Asia\/Thimphu",
    "Asia\/Tokyo",
    "Asia\/Tomsk",
    "Asia\/Ulaanbaatar",
    "Asia\/Urumqi",
    "Asia\/Ust-Nera",
    "Asia\/Vientiane",
    "Asia\/Vladivostok",
    "Asia\/Yakutsk",
    "Asia\/Yangon",
    "Asia\/Yekaterinburg",
    "Asia\/Yerevan",
    "Atlantic\/Azores",
    "Atlantic\/Bermuda",
    "Atlantic\/Canary",
    "Atlantic\/Cape_Verde",
    "Atlantic\/Faroe",
    "Atlantic\/Madeira",
    "Atlantic\/Reykjavik",
    "Atlantic\/South_Georgia",
    "Atlantic\/St_Helena",
    "Atlantic\/Stanley",
    "Australia\/Adelaide",
    "Australia\/Brisbane",
    "Australia\/Broken_Hill",
    "Australia\/Darwin",
    "Australia\/Eucla",
    "Australia\/Hobart",
    "Australia\/Lindeman",
    "Australia\/Lord_Howe",
    "Australia\/Melbourne",
    "Australia\/Perth",
    "Australia\/Sydney",
    "Europe\/Amsterdam",
    "Europe\/Andorra",
    "Europe\/Astrakhan",
    "Europe\/Athens",
    "Europe\/Belgrade",
    "Europe\/Berlin",
    "Europe\/Bratislava",
    "Europe\/Brussels",
    "Europe\/Bucharest",
    "Europe\/Budapest",
    "Europe\/Busingen",
    "Europe\/Chisinau",
    "Europe\/Copenhagen",
    "Europe\/Dublin",
    "Europe\/Gibraltar",
    "Europe\/Guernsey",
    "Europe\/Helsinki",
    "Europe\/Isle_of_Man",
    "Europe\/Istanbul",
    "Europe\/Jersey",
    "Europe\/Kaliningrad",
    "Europe\/Kirov",
    "Europe\/Kyiv",
    "Europe\/Lisbon",
    "Europe\/Ljubljana",
    "Europe\/London",
    "Europe\/Luxembourg",
    "Europe\/Madrid",
    "Europe\/Malta",
    "Europe\/Mariehamn",
    "Europe\/Minsk",
    "Europe\/Monaco",
    "Europe\/Moscow",
    "Europe\/Oslo",
    "Europe\/Paris",
    "Europe\/Podgorica",
    "Europe\/Prague",
    "Europe\/Riga",
    "Europe\/Rome",
    "Europe\/Samara",
    "Europe\/San_Marino",
    "Europe\/Sarajevo",
    "Europe\/Saratov",
    "Europe\/Simferopol",
    "Europe\/Skopje",
    "Europe\/Sofia",
    "Europe\/Stockholm",
    "Europe\/Tallinn",
    "Europe\/Tirane",
    "Europe\/Ulyanovsk",
    "Europe\/Vaduz",
    "Europe\/Vatican",
    "Europe\/Vienna",
    "Europe\/Vilnius",
    "Europe\/Volgograd",
    "Europe\/Warsaw",
    "Europe\/Zagreb",
    "Europe\/Zurich",
    "Indian\/Antananarivo",
    "Indian\/Chagos",
    "Indian\/Christmas",
    "Indian\/Cocos",
    "Indian\/Comoro",
    "Indian\/Kerguelen",
    "Indian\/Mahe",
    "Indian\/Maldives",
    "Indian\/Mauritius",
    "Indian\/Mayotte",
    "Indian\/Reunion",
    "Pacific\/Apia",
    "Pacific\/Auckland",
    "Pacific\/Bougainville",
    "Pacific\/Chatham",
    "Pacific\/Chuuk",
    "Pacific\/Easter",
    "Pacific\/Efate",
    "Pacific\/Fakaofo",
    "Pacific\/Fiji",
    "Pacific\/Funafuti",
    "Pacific\/Galapagos",
    "Pacific\/Gambier",
    "Pacific\/Guadalcanal",
    "Pacific\/Guam",
    "Pacific\/Honolulu",
    "Pacific\/Kanton",
    "Pacific\/Kiritimati",
    "Pacific\/Kosrae",
    "Pacific\/Kwajalein",
    "Pacific\/Majuro",
    "Pacific\/Marquesas",
    "Pacific\/Midway",
    "Pacific\/Nauru",
    "Pacific\/Niue",
    "Pacific\/Norfolk",
    "Pacific\/Noumea",
    "Pacific\/Pago_Pago",
    "Pacific\/Palau",
    "Pacific\/Pitcairn",
    "Pacific\/Pohnpei",
    "Pacific\/Port_Moresby",
    "Pacific\/Rarotonga",
    "Pacific\/Saipan",
    "Pacific\/Tahiti",
    "Pacific\/Tarawa",
    "Pacific\/Tongatapu",
    "Pacific\/Wake",
    "Pacific\/Wallis",
    "UTC"
]

const timeZoneConfig = [
  { "value": "-12:00", "label": "(UTC-12:00) International Date Line West" },
  { "value": "-11:00", "label": "(UTC-11:00) Coordinated Universal Time-11" },
  { "value": "-10:00", "label": "(UTC-10:00) Aleutian Islands" },
  { "value": "-10:00", "label": "(UTC-10:00) Hawaii" },
  { "value": "-09:30", "label": "(UTC-09:30) Marquesas Islands" },
  { "value": "-09:00", "label": "(UTC-09:00) Alaska" },
  { "value": "-08:00", "label": "(UTC-08:00) Baja California" },
  { "value": "-08:00", "label": "(UTC-08:00) Coordinated Universal Time-08" },
  { "value": "-08:00", "label": "(UTC-08:00) Pacific Time (US & Canada)" },
  { "value": "-07:00", "label": "(UTC-07:00) Mountain Time (US & Canada)" },
  { "value": "-07:00", "label": "(UTC-07:00) La Paz, Mazatlan" },
  { "value": "-07:00", "label": "(UTC-07:00) Arizona" },
  { "value": "-07:00", "label": "(UTC-07:00) Yukon" },
  { "value": "-06:00", "label": "(UTC-06:00) Central America" },
  { "value": "-06:00", "label": "(UTC-06:00) Central Time (US & Canada)" },
  { "value": "-06:00", "label": "(UTC-06:00) Easter Island" },
  { "value": "-06:00", "label": "(UTC-06:00) Guadalajara, Mexico City, Monterrey" },
  { "value": "-06:00", "label": "(UTC-06:00) Saskawatchewan" },
  { "value": "-05:00", "label": "(UTC-05:00) Bogota, Lima, Quito, Rio Branco" },
  { "value": "-05:00", "label": "(UTC-05:00) Chetumal" },
  { "value": "-05:00", "label": "(UTC-05:00) Eastern Time (US & Canada)" },
  { "value": "-05:00", "label": "(UTC-05:00) Haiti" },
  { "value": "-05:00", "label": "(UTC-05:00) Havana" },
  { "value": "-05:00", "label": "(UTC-05:00) Indiana (East)" },
  { "value": "-05:00", "label": "(UTC-05:00) Turks and Caicos" },
  { "value": "-04:00", "label": "(UTC-04:00) Atlantic Time (Canada)" },
  { "value": "-04:00", "label": "(UTC-04:00) Caracas" },
  { "value": "-04:00", "label": "(UTC-04:00) Cuiaba" },
  { "value": "-04:00", "label": "(UTC-04:00) George Town, La Paz, Manaus, San Juan" },
  { "value": "-04:00", "label": "(UTC-04:00) Santiago" },
  { "value": "-03:30", "label": "(UTC-03:30) Newfoundland" },
  { "value": "-03:00", "label": "(UTC-03:00) Araguaina" },
  { "value": "-03:00", "label": "(UTC-03:00) Asuncion" },
  { "value": "-03:00", "label": "(UTC-03:00) Brasilia" },
  { "value": "-03:00", "label": "(UTC-03:00) Cayenne, Fortaleza" },
  { "value": "-03:00", "label": "(UTC-03:00) City of Buenos Aires" },
  { "value": "-03:00", "label": "(UTC-03:00) Montevideo" },
  { "value": "-03:00", "label": "(UTC-03:00) Punta Arenas" },
  { "value": "-03:00", "label": "(UTC-03:00) Saint Pierre and Miquelon" },
  { "value": "-03:00", "label": "(UTC-03:00) Salvador" },
  { "value": "-02:00", "label": "(UTC-02:00) Coordinated Universal Time-02" },
  { "value": "-02:00", "label": "(UTC-02:00) Mid-Atlantic" },
  { "value": "-02:00", "label": "(UTC-02:00) Greenland" },
  { "value": "-01:00", "label": "(UTC-01:00) Azores" },
  { "value": "-01:00", "label": "(UTC-01:00) Cabo Verde Islands" },
  { "value": "+00:00", "label": "(UTC+00:00) Dublin, Edinburgh, Lisbon, London" },
  { "value": "+00:00", "label": "(UTC+00:00) Monrovia, Reykjavik" },
  { "value": "+00:00", "label": "(UTC+00:00) Sao Tome" },
  { "value": "+01:00", "label": "(UTC+01:00) Casablanca" },
  { "value": "+01:00", "label": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Paris, Stockholm, Vienna" },
  { "value": "+01:00", "label": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague" },
  { "value": "+01:00", "label": "(UTC+01:00) Bruselles, Copenhagen, Madrid" },
  { "value": "+01:00", "label": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb" },
  { "value": "+01:00", "label": "(UTC+01:00) West Central Africa" },
  { "value": "+02:00", "label": "(UTC+02:00) Athens, Bucharest" },
  { "value": "+02:00", "label": "(UTC+02:00) Beirut" },
  { "value": "+02:00", "label": "(UTC+02:00) Cairo" },
  { "value": "+02:00", "label": "(UTC+02:00) Chisinau" },
  { "value": "+02:00", "label": "(UTC+02:00) Gaza" },
  { "value": "+02:00", "label": "(UTC+02:00) Harare, Pretoria" },
  { "value": "+02:00", "label": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius" },
  { "value": "+02:00", "label": "(UTC+02:00) Jerusalem" },
  { "value": "+02:00", "label": "(UTC+02:00) Juba" },
  { "value": "+02:00", "label": "(UTC+02:00) Kaliningrad" },
  { "value": "+02:00", "label": "(UTC+02:00) Khartoum" },
  { "value": "+02:00", "label": "(UTC+02:00) Tripoli" },
  { "value": "+02:00", "label": "(UTC+02:00) Windhoek" },
  { "value": "+03:00", "label": "(UTC+03:00) Amman" },
  { "value": "+03:00", "label": "(UTC+03:00) Baghdad" },
  { "value": "+03:00", "label": "(UTC+03:00) Damascus" },
  { "value": "+03:00", "label": "(UTC+03:00) Istanbul" },
  { "value": "+03:00", "label": "(UTC+03:00) Kuwait, Riyadh" },
  { "value": "+03:00", "label": "(UTC+03:00) Minsk" },
  { "value": "+03:00", "label": "(UTC+03:00) Moscow, St. Petersburg" },
  { "value": "+03:30", "label": "(UTC+03:30) Nairobi" },
  { "value": "+03:30", "label": "(UTC+03:30) Volgograd" },
  { "value": "+03:30", "label": "(UTC+03:30) Tehran" },
  { "value": "+04:00", "label": "(UTC+04:00) Abu Dhabi, Muscat" },
  { "value": "+04:00", "label": "(UTC+04:00) Astrakhan, Ulyanovsk" },
  { "value": "+04:00", "label": "(UTC+04:00) Baku" },
  { "value": "+04:00", "label": "(UTC+04:00) Izhevsk, Samara" },
  { "value": "+04:00", "label": "(UTC+04:00) Port Louis" },
  { "value": "+04:00", "label": "(UTC+04:00) Saratov" },
  { "value": "+04:00", "label": "(UTC+04:00) Tibilisi" },
  { "value": "+04:00", "label": "(UTC+04:00) Yerevan" },
  { "value": "+04:30", "label": "(UTC+04:30) Kabul" },
  { "value": "+05:00", "label": "(UTC+05:00) Ashgabat, Tashkent" },
  { "value": "+05:00", "label": "(UTC+05:00) Astana" },
  { "value": "+05:00", "label": "(UTC+05:00) Ekaterinburg" },
  { "value": "+05:00", "label": "(UTC+05:00) Islamabad, Karachi" },
  { "value": "+05:30", "label": "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi" },
  { "value": "+05:30", "label": "(UTC+05:30) Sir Jayawardenepura" },
  { "value": "+05:45", "label": "(UTC+05:45) Kathmandu" },
  { "value": "+06:00", "label": "(UTC+06:00) Astana" },
  { "value": "+06:00", "label": "(UTC+06:00) Bishkek" },
  { "value": "+06:00", "label": "(UTC+06:00) Dhakka" },
  { "value": "+06:00", "label": "(UTC+06:00) Omsk" },
  { "value": "+06:30", "label": "(UTC+06:30) Yangon (Rangoon)" },
  { "value": "+07:00", "label": "(UTC+07:00) Bangkok, Hanoi, Jakarta" },
  { "value": "+07:00", "label": "(UTC+07:00) Bornol, Gorno-Altaysk" },
  { "value": "+07:00", "label": "(UTC+07:00) Hovd" },
  { "value": "+07:00", "label": "(UTC+07:00) Krasnoyarsk" },
  { "value": "+07:00", "label": "(UTC+07:00) Novosibirsk" },
  { "value": "+07:00", "label": "(UTC+07:00) Tomsk" },
  { "value": "+08:00", "label": "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi" },
  { "value": "+08:00", "label": "(UTC+08:00) Irkutsk" },
  { "value": "+08:00", "label": "(UTC+08:00) Kula Lumpur, Singapore" },
  { "value": "+08:00", "label": "(UTC+08:00) Perth" },
  { "value": "+08:00", "label": "(UTC+08:00) Taipei" },
  { "value": "+08:00", "label": "(UTC+08:00) Ulaanbaatar" },
  { "value": "+08:45", "label": "(UTC+08:45) Eucla" },
  { "value": "+09:00", "label": "(UTC+09:00) Chita" },
  { "value": "+09:00", "label": "(UTC+09:00) Osaka, Sapporo, Tokyo" },
  { "value": "+09:00", "label": "(UTC+09:00) Pyongyang" },
  { "value": "+09:00", "label": "(UTC+09:00) Seoul" },
  { "value": "+09:00", "label": "(UTC+09:00) Yakutsk" },
  { "value": "+09:30", "label": "(UTC+09:30) Adelaide" },
  { "value": "+09:30", "label": "(UTC+09:30) Darwin" },
  { "value": "+10:00", "label": "(UTC+10:00) Brisbane" },
  { "value": "+10:00", "label": "(UTC+10:00) Sydney, Canberra, Melbourne" },
  { "value": "+10:00", "label": "(UTC+10:00) Guam, Port Moresby" },
  { "value": "+10:00", "label": "(UTC+10:00) Hobart" },
  { "value": "+10:00", "label": "(UTC+10:00) Vladivostok" },
  { "value": "+10:30", "label": "(UTC+10:30) Lord Howe Island" },
  { "value": "+11:00", "label": "(UTC+11:00) Bougainville Island" },
  { "value": "+11:00", "label": "(UTC+11:00) Chokurdakh" },
  { "value": "+11:00", "label": "(UTC+11:00) Magadan" },
  { "value": "+11:00", "label": "(UTC+11:00) Norfolk Island" },
  { "value": "+11:00", "label": "(UTC+11:00) Sakhalin" },
  { "value": "+11:00", "label": "(UTC+11:00) Solomon Islands, New Caledonia" },
  { "value": "+12:00", "label": "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatskiy" },
  { "value": "+12:00", "label": "(UTC+12:00) Auckland, Wellington" },
  { "value": "+12:00", "label": "(UTC+12:00) Coordinated Universal Time +12" },
  { "value": "+12:00", "label": "(UTC+12:00) Fiji" },
  { "value": "+12:45", "label": "(UTC+12:45) Chatham Islands" },
  { "value": "+13:00", "label": "(UTC+13:00) Coordinated Universal Time +13" },
  { "value": "+13:00", "label": "(UTC+13:00) Nukuʻalofa" },
  { "value": "+13:00", "label": "(UTC+13:00) Samoa" },
  { "value": "+14:00", "label": "(UTC+14:00) Kiritimati Island" }
]

export { Timezones, timeZoneConfig }